import { trimEnd, kebabCase } from 'lodash';

const files = require.context('.', true, /\.js$/)

let modules = {}

files.keys().forEach(key => {
    if (key === './index.js') return
    
    const name = trimEnd(kebabCase(key), '-js');
    modules[name] = files(key).default
})

export default modules
